// ─────────────────────────────────────────────────────────────────
// V97.141 — Badge laboratoire (Ortho-Analytic / MGD)
//
// Ortho-Analytic et MGD sont deux partenaires A EGALITE. Une cliente peut
// avoir des analyses des deux labos dans le meme plan, et chaque labo a son
// propre formulaire de commande : Anissa doit voir le labo sans avoir a le
// deviner depuis le nom de l'analyse.
//
// Les deux badges ont exactement le meme poids visuel (outline, meme taille,
// meme graisse), et les deux teintes sont calees sur la meme luminance (~0.11,
// contraste ~6.5:1 sur blanc) pour qu'aucun des deux labos ne "pese" plus que
// l'autre a l'oeil. AUCUNE hierarchie n'est suggeree : le choix du labo
// appartient a Anissa, cliente par cliente.
//
// Le prune de MGD est volontairement hors palette semantique du cockpit : le
// rouge y signifie deja erreur (#c44) et l'ambre warning (#856404) — un badge
// rouge ferait lire chaque ligne MGD comme un probleme.
//
// Extrait d'AnalysisSuggestionModal en V97.141 : le badge sert aussi sur la
// carte du plan, la ou Anissa remplit ses fiches de commande. L'info du labo
// disparaissait justement au moment ou elle en a besoin.
// ─────────────────────────────────────────────────────────────────

export const LAB_BADGES = {
  ortho_analytic: { label: 'ORTHO', color: '#4a5f7a' },
  mgd: { label: 'MGD', color: '#75527f' },
};

export default function LabBadge({ sourceLab }) {
  const lab = LAB_BADGES[sourceLab];
  // Labo inconnu (nouveau partenaire pas encore reference) : on affiche le
  // code brut plutot que rien, pour ne jamais masquer la provenance.
  const label = lab ? lab.label : String(sourceLab || '?').toUpperCase();
  const color = lab ? lab.color : '#888';
  return (
    <span
      title={`Laboratoire : ${label}`}
      style={{
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '.1em',
        color,
        border: `1px solid ${color}`,
        borderRadius: 3,
        padding: '1px 5px',
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
